import React from 'react';
import { IonLabel } from '@ionic/react';
import { Controller } from 'react-hook-form';
import PropTypes from 'prop-types';
import { LightTextField, TaupeTextField } from './themes';

const StyledTextField = ({
  control = null,
  defaultValue = '',
  error = null,
  name,
  placeholder = null,
  position = 'stacked',
  required = false,
  rules = null,
  theme = 'taupe',
  title = null,
  type = 'text',
  InputProps = null,
  emptyFallback = false,
  onKeyUp = () => {},
  hideErrorHelper = false,
}) => (
  <div>
    <IonLabel style={{ color: '#2d2d2d', lineHeight: 1.25 }} position={position}>
      {title}
    </IonLabel>
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      rules={{ required, ...rules }}
      render={({ field: { value, ...rest } }) => (theme === 'light' ? (
        <LightTextField
            // eslint-disable-next-line react/jsx-props-no-spreading
          {...rest}
          value={!emptyFallback ? value : value || ''}
          placeholder={placeholder}
          error={!!error?.message}
          helperText={!hideErrorHelper && error?.message}
          InputProps={{
            inputProps: {
              autoCapitalize: type !== 'password' && 'on',
              inputMode: type,
            },
            ...InputProps,
          }}
          type={type === 'password' ? 'password' : 'text'}
          size="small"
          fullWidth
          onKeyUp={onKeyUp}
        />
      ) : (
        <TaupeTextField
            // eslint-disable-next-line react/jsx-props-no-spreading
          {...rest}
          value={!emptyFallback ? value : value || ''}
          placeholder={placeholder}
          error={!!error?.message}
          helperText={!hideErrorHelper && error?.message}
          InputProps={{
            inputProps: {
              autoCapitalize: type !== 'password' && 'on',
              inputMode: type,
            },
            ...InputProps,
          }}
          type={type === 'password' ? 'password' : 'text'}
          size="small"
          fullWidth
          onKeyUp={onKeyUp}
        />
      ))}
    />
  </div>
);

StyledTextField.propTypes = {
  control: PropTypes.oneOfType([PropTypes.any]),
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  error: PropTypes.shape({
    message: PropTypes.string,
  }),
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  position: PropTypes.string,
  required: PropTypes.bool,
  theme: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string,
  InputProps: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  rules: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  emptyFallback: PropTypes.bool,
  onKeyUp: PropTypes.func,
  hideErrorHelper: PropTypes.bool,
};


export default StyledTextField;
